
import axios from 'axios';
import useSesion from '../hooks/stateHooks/useSession';

function useLogin() {
    const _session = useSesion();

    const baseUrl = process.env.REACT_APP_API_HOST;

    async function doLogin(login) {
        const endpoint = '/api/login/start';
        const api = axios.create({ baseURL: baseUrl + endpoint });
        let answer = ""
        await api.post('',
            login,
            {
                headers: {}
            })
            .then(response => {
                _session.startSesion(response.data.token);
                _session.setCurrentUser(response.data.user);
                answer = "SUCCESS";
            })
            .catch(error => {
                _session.endSesion();
                answer = "ERROR";
            });
        return answer;
    }

    return {
        doLogin
    }
}

export default useLogin;